export const SENSOR_ACTION_SIDES = {
  ON_TRUE: 'on_true',
  ON_FALSE: 'on_false',
} as const;

export type SensorActionSide = (typeof SENSOR_ACTION_SIDES)[keyof typeof SENSOR_ACTION_SIDES];

export const SENSOR_TRIGGER_NAMES = {
  BEAM_BROKEN: 'beam_broken_trigger',
  DETECTED: 'detected_trigger',
  GREATER_THAN: 'greater_than_trigger',
  LESS_THAN: 'less_than_trigger',
  BETWEEN: 'between_trigger',
} as const;

export type SensorTriggerName = (typeof SENSOR_TRIGGER_NAMES)[keyof typeof SENSOR_TRIGGER_NAMES];

export const SENSOR_TRIGGER_ARG_KEYS = {
  DISTANCE: 'distance',
  DISTANCE_NEAR: 'distance_near',
  DISTANCE_FAR: 'distance_far',
} as const;

export type SensorTriggerArgKey = (typeof SENSOR_TRIGGER_ARG_KEYS)[keyof typeof SENSOR_TRIGGER_ARG_KEYS];

export const BOOLEAN_TRIGGER_NAMES = new Set<SensorTriggerName>([SENSOR_TRIGGER_NAMES.BEAM_BROKEN, SENSOR_TRIGGER_NAMES.DETECTED]);

export const DISTANCE_TRIGGER_NAMES = new Set<SensorTriggerName>([
  SENSOR_TRIGGER_NAMES.GREATER_THAN,
  SENSOR_TRIGGER_NAMES.LESS_THAN,
  SENSOR_TRIGGER_NAMES.BETWEEN,
]);
